<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'createDialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Cho ý kiến kết luận chỉ đạo
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="200px"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Thời hạn hoàn thành" prop="deadline">
              <el-date-picker
                :disabled=isDisabledDeadlineSelector
                v-model="form.deadline"
                type="date"
                size="medium"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                placeholder="dd/mm/yyyy"
                format="dd/MM/yyyy"
                :picker-options="completeDatePickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Ý kiến chỉ đạo của LĐ" prop="directionContent">
              <el-input
                v-model="form.directionContent"
                type="textarea"
                placeholder="Ý kiến chỉ đạo của LĐ"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                show-word-limit
                maxlength="2000"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="save"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Lưu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
          >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import CustomDialog from "../../common/custom-dialog";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import Vue from "vue";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import hcCaseCommandsService from "../../../services/hcCaseCommandsService";
import hcCaseCommandsCommonService from "../../../services/hcCaseCommandsCommonService";

export default {
  name: "hc-command-cho-y-kien-dialog",
  props: ["isOpen", "id"],
  mixins: [handleRequestErrorMixin],
  components: { CustomDialog },

  data() {
    return {
      isDisabledDeadlineSelector: false,
      form: {
        deadline: null,
        directionContent: null
      },
      rules: {
        deadline: null,
        directionContent: null
      },
      hcCaseCommands: null,
      hcCaseCommandsCommon: null,
      completeDatePickerOptions: {
        disabledDate: null
      }
    };
  },

  created() {
    this.initValidationRules();
    this.loadHcCaseCommands()
      .then(() => this.loadHcCaseCommandsCommon())
      .then(() => this.initForm());
  },

  methods: {
    initForm() {
      if(this.hcCaseCommands) {
        if (this.hcCaseCommands.nextDeadline2) {
          this.isDisabledDeadlineSelector = true;
          this.form.deadline = new Date(this.hcCaseCommands.nextDeadline2);
        } else if (this.hcCaseCommands.nextDeadline) {
          this.form.deadline = new Date(this.hcCaseCommands.nextDeadline);
        } else if (this.hcCaseCommands.deadline) {
          this.form.deadline = new Date(this.hcCaseCommands.deadline);
        } else {
          this.form.deadline = null;
        }
      }

      this.completeDatePickerOptions.disabledDate = time =>
        !(!this.form.deadline || time.getTime() > this.form.deadline.getTime());

      this.form.directionContent = this.hcCaseCommandsCommon.directionContent;
    },

    loadHcCaseCommands() {
      return hcCaseCommandsService
        .findById(this.id)
        .then(response => (this.hcCaseCommands = response.data));
    },

    loadHcCaseCommandsCommon() {
      return hcCaseCommandsCommonService
        .findById(this.hcCaseCommands.hcCaseCommandsCommonId)
        .then(response => (this.hcCaseCommandsCommon = response.data));
    },

    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };
      Vue.set(this.rules, "deadline", [defaultRequiredConstrains]);
      Vue.set(this.rules, "directionContent", [defaultRequiredConstrains]);
    },

    convertToSubmitForm() {
      return {
        deadline: this.form.deadline ? this.form.deadline.getTime() : null,
        directionContent: this.form.directionContent
      };
    },

    validateForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (!valid) {
            this.$message({
              message: "Có lỗi nhập liệu. Vui lòng kiểm tra lại",
              type: "error"
            });
          } else {
            resolve();
          }
        });
      });
    },

    validateDeadline() {
      const commandsDate = this.hcCaseCommandsCommon.commandsDate
        ? new Date(this.hcCaseCommandsCommon.commandsDate)
        : null;
      const deadline = this.hcCaseCommands.deadline
        ? new Date(this.hcCaseCommands.deadline)
        : null;
      const nextDeadline = this.hcCaseCommands.nextDeadline
        ? new Date(this.hcCaseCommands.nextDeadline)
        : null;
      const nextDeadline2 = this.hcCaseCommands.nextDeadline2
        ? new Date(this.hcCaseCommands.nextDeadline2)
        : null;

      return new Promise((resolve, reject) => {
        if (deadline === null) {
          // Thời hạn hoàn thành không được nhỏ hơn ngày chỉ đạo
          if (this.form.deadline.getTime() < commandsDate.getTime()) {
            this.$message({
              message: errorMessageFilter({
                errorCode: "hcCommands.invalidCommandsDateAndDeadline"
              }),
              type: "error"
            });
            reject(new Error('hcCommands.invalidCommandsDateAndDeadline'));
          }
        } else if (nextDeadline === null) {
          // Thời gian được gia hạn lần 1 phải lớn hơn thời hạn hoàn thành
          if (this.form.deadline.getTime() <= deadline.getTime()) {
            this.$message({
              message: errorMessageFilter({
                errorCode: "hcCommands.invalidDeadlineAndNextDeadline"
              }),
              type: "error"
            });
            reject(new Error('hcCommands.invalidDeadlineAndNextDeadline'));
          }
        } else if (nextDeadline2 === null) {
          // Thời gian được gia hạn lần 2 phải lớn hơn thời gian được gia hạn lần 1
          if (this.form.deadline.getTime() <= nextDeadline.getTime()) {
            this.$message({
              message: errorMessageFilter({
                errorCode: "hcCommands.invalidNextDeadlineAndNextDeadline2"
              }),
              type: "error"
            });
            reject(new Error('hcCommands.invalidNextDeadlineAndNextDeadline2'));
          }
        }

        resolve();
      })
    },

    save() {
      return this.validateForm()
        .then(() => this.validateDeadline())
        .then(() => {
          let submitForm = this.convertToSubmitForm();
          return hcCaseCommandsService
            .choYKien(this.id, submitForm)
            .then(response => response.data);
        })
        .then(hcCaseCommands => {
          this.$message({
            message: errorMessageFilter({
              errorCode: "hcCommand.choYkienSuccess"
            }),
            type: "success"
          });
          this.$emit("success", { result: hcCaseCommands });
        })
        .catch(error => {
          this.commonHandleRequestError(error);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/hc-command-cho-y-kien-dialog.vue